import { daysLeftLabel } from 'app/report/pages/ProductExperiration/expiry-labels';
import { ExpiryAlertGroup, ExpiryAlertLot } from 'domain/notification';
import { ReactElement } from 'react';
import { DateFormat, format } from 'shared/utils/date';
import ExpiryAlertsStyled, { AlertTone } from './ExpiryAlerts.styled';

const { SectionHeader, SectionTitle, SectionHint, LotRow, LotInfo, LotName, LotMeta, LotWhen, DaysText, ExpiryDate, MoreLink } =
  ExpiryAlertsStyled;

interface ExpiryAlertSectionProps {
  title: string;
  hint: string;
  tone: AlertTone;
  group: ExpiryAlertGroup;
  moreLabel: string;
  onShowAll: () => void;
}

const unitsLabel = (units: number): string => `${units.toLocaleString('es-PE')} ${units === 1 ? 'unidad' : 'unidades'}`;

const AlertLot = ({ lot, tone }: { lot: ExpiryAlertLot; tone: AlertTone }): ReactElement => (
  <LotRow>
    <LotInfo>
      <LotName title={lot.productName}>{lot.productName}</LotName>
      <LotMeta>
        Lote {lot.code} · {unitsLabel(lot.stock)}
      </LotMeta>
    </LotInfo>
    <LotWhen>
      <DaysText $tone={tone}>{daysLeftLabel(lot.daysLeft)}</DaysText>
      <ExpiryDate>{format(lot.expiryDate, DateFormat.Default)}</ExpiryDate>
    </LotWhen>
  </LotRow>
);

const ExpiryAlertSection = ({ title, hint, tone, group, moreLabel, onShowAll }: ExpiryAlertSectionProps): ReactElement | null => {
  if (group.count === 0) return null;
  const hiddenLots = group.count - group.lots.length;

  return (
    <section aria-label={title}>
      <SectionHeader $tone={tone}>
        <SectionTitle>
          {title} · {group.count}
        </SectionTitle>
        <SectionHint>{hint}</SectionHint>
      </SectionHeader>
      {group.lots.map((lot) => (
        <AlertLot key={lot.id} lot={lot} tone={tone} />
      ))}
      {hiddenLots > 0 && <MoreLink onClick={onShowAll}>{moreLabel}</MoreLink>}
    </section>
  );
};

export default ExpiryAlertSection;
